import type { ColumnDef } from "@tanstack/react-table";
import type { ColumnConfig } from "@repo/types/ui/tables";

export function buildColumn<T>(
  config: ColumnConfig<T>,
  options?: Partial<ColumnDef<T>>,
): ColumnDef<T> {
  const { key, label } = config;

  return {
    id: key,
    header: label,
    accessorKey: key,
    ...options,
  };
}

